export default {"src":"/_next/static/media/updates.1fb61b06.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};